import { MapPin } from "lucide-react";

const SITE_LOCATION_MAP_URL =
  "https://customer-assets.emergentagent.com/job_expert-info-days/artifacts/gwutr5v2_site%20location%20map.png";

/* Site location section — OSI topographic map showing the project boundary
   in the townlands of Sraheendoo, Brackloonbeg, Ben More and Galboley. */
export default function SiteLocation() {
  return (
    <section id="location" className="bg-[#F9F8F6]" data-testid="site-location-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5 reveal">
            <p className="overline mb-4">Where it is</p>
            <h2 className="font-serif-display text-3xl lg:text-4xl tracking-tight mb-5">
              6.5 kilometres north of Loughrea town.
            </h2>
            <p className="text-[15px] leading-relaxed text-[#2A2B2A]/85 mb-4">
              The site spans the townlands of <strong>Sraheendoo, Brackloonbeg,
              Ben More and Galboley</strong> in County Galway. It is a relatively
              flat patchwork of fields enclosed by mature hedgerows and treelines,
              currently used for agricultural grazing.
            </p>
            <p className="text-[15px] leading-relaxed text-[#2A2B2A]/85">
              Access will be from the <strong>R350</strong> and{" "}
              <strong>L8184</strong>, approached via the <strong>M6</strong> and{" "}
              <strong>N65</strong>. Five carefully designed entrances are
              proposed.
            </p>

            <dl className="mt-8 grid grid-cols-2 gap-y-5 text-[13px]">
              <dt className="text-[#63635E]">County</dt>
              <dd className="text-[#2A2B2A] font-medium">Galway</dd>
              <dt className="text-[#63635E]">Nearest town</dt>
              <dd className="text-[#2A2B2A] font-medium">Loughrea</dd>
              <dt className="text-[#63635E]">Distance to town</dt>
              <dd className="text-[#2A2B2A] font-medium">6.5 km north</dd>
              <dt className="text-[#63635E]">Primary access</dt>
              <dd className="text-[#2A2B2A] font-medium">R350 via M6 / N65</dd>
            </dl>

            <div className="mt-8 flex items-start gap-3 p-4 bg-white border border-[#E0DCD3] rounded-sm">
              <MapPin className="h-4 w-4 text-[#3A4B3A] mt-0.5 shrink-0" />
              <div>
                <p className="text-[11px] tracking-[0.18em] uppercase font-semibold text-[#3A4B3A]">
                  Site boundary
                </p>
                <p className="text-[12.5px] text-[#63635E] mt-1">
                  The site boundary is shown in <span className="text-[#C8302A] font-semibold">red</span> on the OSI map, surrounding the townlands of Sraheendoo, Brackloonbeg, Galboley and Ben More.
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 reveal">
            <figure className="rounded-sm border border-[#E0DCD3] bg-white overflow-hidden">
              <a
                href={SITE_LOCATION_MAP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="site-location-map-link"
                className="block group"
                aria-label="Open full-size site location map in a new tab"
              >
                <img
                  src={SITE_LOCATION_MAP_URL}
                  alt="Ordnance Survey Ireland map showing the Loughrea Solar Farm site boundary outlined in red, in the townlands of Sraheendoo, Brackloonbeg, Galboley and Ben More — 6.5 km north of Loughrea town"
                  className="block w-full h-auto transition-transform duration-700 group-hover:scale-[1.02]"
                  loading="lazy"
                />
              </a>
              <figcaption className="border-t border-[#E0DCD3] bg-[#F9F8F6] px-5 py-3 flex flex-wrap items-center gap-x-6 gap-y-1 text-[11px] text-[#63635E]">
                <span className="text-[#4C4538] font-semibold tracking-[0.16em] uppercase">
                  Site location · OSI topographic basemap
                </span>
                <span className="ml-auto italic">Tap to view full size · © OSI / Tailte Éireann</span>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}
